const getters = {
    getMHDInventoryDrawerState: state => {
        return state.mhdInventoryDrawerState
    },
    getMHDInventoryItems: state => {
        return state.mhdItems
    },

}

export default getters
